import { createContext } from 'react'
import { SelectedDate, SelectedDateAction } from './types'

export const SelectedDateContext = createContext<SelectedDate | undefined>(
  undefined
)

export const SelectedDateDispatchContext = createContext<
  React.Dispatch<SelectedDateAction> | undefined
>(undefined)
